<template>
    <div class="mt-2">
        <div>
            <h2 class="text-xl font-semibold text-center uppercase">Orden de trabajo</h2>
        </div>

        <div class="py-2">
            <span v-html="this.codigoBarras" class="flex justify-center w-full"></span>
        </div>
        
        <div class="grid grid-cols-3 text-sm my-2">
            <div class="text-left">Nº OT:</div>
            <div class="text-right col-span-2">{{ datosOT.numeroOT }}</div>

            <div class="text-left">Tipo OT:</div>
            <div class="text-right col-span-2">{{ datosOT.tipoOT }}</div>

            <div class="text-left">Fecha:</div>
            <div class="text-right col-span-2">{{ datosOT.fecha }}</div>

            <div class="text-left">Local:</div>
            <div class="text-right col-span-2">{{ datosOT.sucursal }}</div>

            <div class="text-left">Entrega:</div>
            <div class="text-right col-span-2">{{ datosOT.fechaRetiro }}</div>

            <div class="text-left">Cliente:</div>
            <div class="text-right col-span-2">{{ datosOT.nombre }}</div>

            <div class="text-left">Asesor:</div>
            <div class="text-right col-span-2">{{ datosOT.nombreVendedor }}</div>

            <div class="text-left">Teléfono:</div>
            <div class="text-right col-span-2">{{ datosOT.telefono }}</div>
            
            <template v-if="datosOT.profesional">
                <div class="text-left">Profesional:</div>
                <div class="text-right col-span-2">{{ datosOT.profesional }}</div>
            </template>
            <template v-if="datosOT.laboratorio">
                <div class="text-left">Laboratorio:</div>
                <div class="text-right col-span-2">{{ datosOT.laboratorio }}</div>
            </template>
        </div>

        <div class="grid grid-cols-3 text-sm my-2 border-t border-gray-200 pt-2">
            <div class="text-left col-span-3 text-base font-bold uppercase mb-1">
                Detalle lentes
            </div>

            <template v-for="(lente, indice) in datosOT.lentes" :key="indice">
                <div class="text-left text-lg col-span-3 font-semibold mt-2 border-b border-gray-100">
                    {{ `${lente.tipo}:` }}
                </div>

                <div class="text-left">Armazón:</div>
                <div class="text-right col-span-2">{{ lente.armazon }}</div>

                <div class="text-left">Cristal:</div>
                <div class="text-right col-span-2">{{ lente.cristal }}</div>

                <div class="text-left">Filtro:</div>
                <div class="text-right col-span-2">{{ lente.filtro }}</div>

                <template v-if="lente.tipo == 'Multifocal'">
                    <div class="text-left">T.multifocal:</div>
                    <div class="text-right col-span-2">{{ lente.tipoMultifocal }}</div>
                </template>

                <div class="text-left font-medium">Precio Lente:</div>
                <div class="text-right col-span-2 font-medium">{{ `$ ${this.formatearCifra(lente.valor)}` }}</div>
            </template>
        </div>

        <div class="grid grid-cols-3 text-sm my-2 border-t border-gray-400 pt-2">
            <div class="text-left text-sm font-bold uppercase mt-1 border-b border-gray-300 pb-1">Total con descuento:</div>
            <div class="text-right col-span-2 text-lg font-bold mt-1 border-b border-gray-300 pb-1">{{ `$ ${this.formatearCifra(datosOT.totalFinal || datosOT.total)}` }}</div>

            <div class="text-left mt-2">Abono:</div>
            <div class="text-right col-span-2 mt-2">{{ `$ ${this.formatearCifra(datosOT.abono)}` }}</div>
            
            <div class="text-left text-xl font-bold uppercase">Saldo:</div>
            <div class="text-right col-span-2 text-xl font-bold">{{ `$ ${this.formatearCifra(datosOT.saldo)}` }}</div>
        </div>
    </div>
</template>

<script>
import { separarPorMiles } from "@/utils/helpers";
import OTService from "@/services/OrdenTrabajoService";

export default {
    data() {
        return {
            codigoBarras: ''
        }
    },
    methods: {
        formatearCifra(cifra) {
            return separarPorMiles(cifra);
        },
        obtenerCodigoBarras(numeroOT) {
            OTService.obtenerCodigoBarras(numeroOT.toString()).
            then((response) => {
                this.codigoBarras = response.data;
            });
        }
    },
    props: {
        datosOT: {
            type: Object,
            default: null
        }
    },
    mounted() {
        this.obtenerCodigoBarras(this.datosOT.numeroOT);
    }
}
</script>